import * as React from "react";
const LinkedinWhite = (props) => (
  <svg
    width={23}
    height={22}
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.3033 8.15246e-05H1.69672C1.25186 -0.00415613 0.823375 0.156962 0.505281 0.448083C0.187188 0.739204 0.00546934 1.13655 0 1.55293V19.9789C0.00645845 20.3946 0.188612 20.7911 0.506598 21.0814C0.824584 21.3718 1.25251 21.5324 1.69672 21.5282H21.3033C21.7482 21.5315 22.1764 21.3698 22.4943 21.0785C22.8122 20.7872 22.994 20.39 23 19.9736V1.54764C22.9921 1.13248 22.8094 0.737026 22.4917 0.447241C22.174 0.157457 21.7469 -0.00323974 21.3033 8.15246e-05Z"
      fill="white"
    />
    <path
      d="M3.15928 8.05633H6.73444V18.8371H3.15928V8.05633ZM4.94784 2.69092C5.3579 2.69092 5.75874 2.8049 6.09966 3.01844C6.44058 3.23199 6.70626 3.5355 6.86309 3.89058C7.01992 4.24566 7.06085 4.63635 6.98071 5.01324C6.90057 5.39013 6.70295 5.73627 6.41286 6.00788C6.12277 6.2795 5.75325 6.46437 5.35102 6.53912C4.9488 6.61387 4.53196 6.57513 4.15323 6.42781C3.7745 6.28049 3.45091 6.03121 3.22338 5.7115C2.99585 5.39179 2.87461 5.01602 2.875 4.63172C2.87552 4.11682 3.09414 3.62317 3.48282 3.25925C3.8715 2.89534 4.39843 2.69092 4.94784 2.69092ZM8.97705 8.05633H12.4042V9.53645H12.4515C12.9293 8.68908 14.094 7.79546 15.8332 7.79546C19.4538 7.78806 20.125 10.0212 20.125 12.9167V18.8371H16.5498V13.592C16.5498 12.3431 16.5262 10.7353 14.6922 10.7353C12.8582 10.7353 12.5463 12.097 12.5463 13.5106V18.8371H8.97705V8.05633Z"
      fill="black"
    />
  </svg>
);
export default LinkedinWhite;
